import styled from 'styled-components';

export const AddToCartStyled = styled.div`
  .btn-base {
    .btn {
      &.btn-primary {
        color: ${(props) => props?.theme?.text?.lightBlue};
        background: transparent;
        border: 1px solid ${(props) => props?.theme?.text?.lightBlue};
        position: relative;

        &:hover {
          color: ${(props) => props?.theme?.color?.white};
          background: ${(props) => props?.theme?.text?.lightBlue};
        }
      }
    }
    &.list-btn {
      .btn {
        &.btn-primary {
          margin: 0;
          font-size: 15px;
          line-height: 16px;
          padding: 11px 15px;
          background: ${(props) => props?.theme?.color?.white};
          border-color: ${({ theme }) => theme?.blue?.royal};
          color: ${(props) => props?.theme?.blue?.royal};

          &.btn-added {
            color: ${(props) => props?.theme?.blue?.royal};
            background: ${(props) => props?.theme?.royalBlue?.off};
            border-color: ${(props) => props?.theme?.royalBlue?.off};
            padding: 11px 54px 11px 15px;
            width: 118px;

            .ic-added {
              width: 40px !important;
              height: 38px !important;
              box-sizing: border-box;
              border-radius: 0 7px 7px 0;
              background: ${({ theme }) => theme?.blue?.royal};
              position: absolute;
              top: 0px;
              right: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
    &.detail-btn {
      .btn {
        &.btn-primary {
          height: 56px;
          margin: 0;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props?.theme?.color?.white};
          background: ${({ theme }) => theme?.blue?.royal};

          &.btn-added {
            color: ${({ theme }) => theme?.blue?.royal};
            background: ${(props) => props?.theme?.royalBlue?.off};
            border-color: ${(props) => props?.theme?.royalBlue?.off};
            padding-right: 76px;

            .ic-added {
              width: 56px !important;
              height: 56px !important;
              border-radius: 0 7px 7px 0;
              background: ${({ theme }) => theme?.blue?.royal};
              position: absolute;
              top: 0px;
              right: 0;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }

          @media (max-width: 480px) {
            min-width: calc(100% - 1px) !important;
          }
        }
      }
    }
  }
  @media (max-width: 480px) {
    width: 100%;
  }
`;
